
import type { App } from 'vue';
import { setupPinia } from './pinia';
import { setupPrimeVue } from './primevue';
import { setupSyncfusion } from './syncfusion';
import { setupRouter } from './router';
import { setupUtility } from './utility';
import { setupDayjs } from './dayjs';
import { setupChartJs } from './chartjs';

export function setupPlugins(app: App) {
    setupUtility(app);
    setupDayjs(app);
    setupChartJs(app);
    setupPinia(app);
    setupPrimeVue(app);
    setupSyncfusion(app);
    setupRouter(app);
}